import React from 'react';
// leaflet
import {
  Map, LayersControl, TileLayer, WMSTileLayer,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

// Layer
import LayerRiver from '../../../components/map/River';

import WmsBoundary from '../../../components/map/WmsBoundary';
import WmsBasin from '../../../components/map/WmsBasin';

const { Overlay } = LayersControl;

const baseUrl = 'https://api-gateway.gistda.or.th/api/2.0/resources/maps';
const apikey = 'm4bUUjGDPc3rdxyb8JHcL8SDhgLHPgRjq2NBeibPIucJkpxuoHahMVwXwRjKTOq6';
const wmsUrl1 = `${baseUrl}/flood/1day/wms?api_key=${apikey}`;
const wmsUrl3 = `${baseUrl}/flood/3days/wms?api_key=${apikey}`;
const wmsUrl7 = `${baseUrl}/flood/7days/wms?api_key=${apikey}`;
const wmsUrl30 = `${baseUrl}/flood/30days/wms?api_key=${apikey}`;
const virrs30 = `${baseUrl}/viirs/30days/wms?api_key=${apikey}`;

export default function floodday() {
  return (
    <Map
      center={[13.7563, 100.5018]}
      zoom={6}
      style={{ height: '1000px', width: '100%' }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <LayersControl>
        <Overlay name="เส้นแม่น้ำ" checked>
          <LayerRiver />
        </Overlay>
        <Overlay name="ขอบเขตการปกครอง">
          <WmsBoundary />
        </Overlay>
        <Overlay name="ขอบเขตลุ่มน้ำ">
          <WmsBasin />
        </Overlay>

        <Overlay name="พื้นที่น้ำท่วม 1 วัน">
          <WMSTileLayer
            url={wmsUrl1}
            version="1.3.0"
            opacity={1}
            transparent
            format="image/png"
            zIndex={999}
            attribution="&copy; <a href=&quot;https://disaster.gistda.or.th/&quot; target='_blank'>Gistda</a> contributors"
          />
        </Overlay>
        <Overlay name="พื้นที่น้ำท่วม 3 วัน">
          <WMSTileLayer
            url={wmsUrl3}
            version="1.3.0"
            opacity={1}
            transparent
            format="image/png"
            zIndex={999}
            attribution="&copy; <a href=&quot;https://disaster.gistda.or.th/&quot; target='_blank'>Gistda</a> contributors"
          />
        </Overlay>
        <Overlay name="พื้นที่น้ำท่วม 7 วัน">
          <WMSTileLayer
            url={wmsUrl7}
            version="1.3.0"
            opacity={1}
            transparent
            format="image/png"
            zIndex={999}
            attribution="&copy; <a href=&quot;https://disaster.gistda.or.th/&quot; target='_blank'>Gistda</a> contributors"
          />
        </Overlay>
        <Overlay name="พื้นที่น้ำท่วม 30วัน">
          <WMSTileLayer
            url={wmsUrl30}
            version="1.3.0"
            opacity={1}
            transparent
            format="image/png"
            zIndex={999}
            attribution="&copy; <a href=&quot;https://disaster.gistda.or.th/&quot; target='_blank'>Gistda</a> contributors"
          />
        </Overlay>

        <Overlay name="ไฟป่า 30วัน">
          <WMSTileLayer
            url={virrs30}
            version="1.3.0"
            opacity={1}
            transparent
            format="image/png"
            zIndex={999}
            attribution="&copy; <a href=&quot;https://disaster.gistda.or.th/&quot; target='_blank'>Gistda</a> contributors"
          />
        </Overlay>

      </LayersControl>
    </Map>
  );
}
